import { API } from '@/BeatoutAPI';
import store, { moduleActionContext } from '@/store';
import { Group, GroupState } from '@/types/group';
import { helpers } from '../helpers';
import { cloneDeep } from 'lodash';
const state = {
    waiting: {},
    active: {},
    finished: {},
    archived: {},
    dataReceived: {
        waiting: false,
        active: false,
        finished: false,
        archived: false
    }
};
const getters = {};
const mutations = {
    set(storestate, { groups, state }) {
        storestate[state] = {};
        Object.entries(groups).forEach(([id, group]) => {
            storestate[state][id] = Group.load(group);
        });
    },
    setDataReceived(state, status) {
        state.dataReceived[status] = true;
    },
};
const actions = {
    async update(context, { groupId, group }) {
        const { dispatch } = groupsModuleActionContext(context);
        const groupWithOutTeams = cloneDeep(group);
        if (groupWithOutTeams.teams !== undefined) {
            delete groupWithOutTeams.teams;
        }
        await API.getRequest().put(`group/${groupId}`, JSON.stringify(groupWithOutTeams));
        if (group.teams) {
            for (const [teamId, team] of Object.entries(group.teams)) {
                await store.dispatch.teams.update({ ...team, id: teamId });
            }
        }
        if (group.state) {
            await dispatch.getGroups(group.state);
        }
    },
    async delete(_context, groupId) {
        //const { commit } = groupsModuleActionContext(context)
        await API.getRequest().delete(`group/${groupId}`);
        //commit.delete(id)
    },
    async create(context, newGroup) {
        const { dispatch } = groupsModuleActionContext(context);
        const response = await API.getRequest().post('group/new', JSON.stringify(newGroup));
        await dispatch.getGroups(GroupState.Waiting);
        return response.status == 200;
    },
    async getGroups(context, state) {
        const { commit } = groupsModuleActionContext(context);
        const response = await API.getRequest().get(`groups/${state}`);
        commit.set({ state, groups: response.data });
        commit.setDataReceived(state);
    },
    async subscribe(context, state) {
        const { dispatch } = groupsModuleActionContext(context);
        await helpers.subscribe(`groups-${state}`, { repeat: 10000 }, async () => {
            dispatch.getGroups(state);
        });
    },
    async unsubscribe(_context, state) {
        await helpers.unsubscribe(`groups-${state}`);
    }
};
const groupsModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default groupsModule;
export const groupsModuleActionContext = (context) => moduleActionContext(context, groupsModule);
